import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import CertificateTable from '@certificates/components/tables/certificate-table/certificate-table.vue';

@Component({
  name: 'bpc-certificates',
  components: {
    'bpc-certificate-table': CertificateTable,
  },
})
export default class Certificates extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
